import { Redirect, useParams } from 'react-router-dom'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/Login/Login.module.scss'
import { Title } from '@src/components/Title/Title'
import { TabList } from '@src/components/Tablist/TabList'
import { AuthFormEnum } from '@src/types/auth'
import { LoginForm } from '@src/pages/Login/LoginForm'
import {
  selectIsAuth,
  selectIsLoading,
} from '@src/store/ducks/auth/selectors'
import { useEffect } from 'react'
import { resetState } from '@src/store/ducks/auth/reducer'
import { AppDispatch } from '@src/store/store'
import { setPageTitle } from '@src/store/ducks/app/reducer'

const tabListOptions:Array<{ url: string, title: string }> = [
  {
    url: '/login/contract',
    title: 'Домашний Интернет и ТВ',
  },
  {
    url: '/login/phone',
    title: 'Приложение COSMOS TV',
  },
]

export const Login = () => {
  const params = useParams<{ type: AuthFormEnum }>()
  const dispatch = useDispatch<AppDispatch>()
  const isAuth = useSelector(selectIsAuth)
  const isLoading = useSelector(selectIsLoading)

  useEffect(() => { dispatch(setPageTitle('Войти в личный кабинет')) }, [dispatch])

  useEffect(() => () => { dispatch(resetState()) }, [dispatch])

  if (isAuth) {
    return <Redirect to="/" />
  }

  return (
    <div id="login" className={cn(style.login, 'container')}>
      <div className={style.login__body}>
        <Title title="Войти в личный кабинет" />
        <div className={style.body}>
          <TabList options={tabListOptions} />
          <LoginForm isLoading={isLoading} type={params.type} />
        </div>
      </div>
    </div>
  )
}
